import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { analyticsUtils } from 'utils';
import { StoreCommonInfo } from 'features/store-common-info';
import { StoreProjects } from 'features/store-projects';
import { StoreReviews } from 'features/store-reviews';
import { ServiceCarousel } from 'common/components/service-components/service-carousel';
import { getRegionId } from 'features/page-model/ducks/get-model';
import { getIsAuthorized } from 'common/selectors/all-cookies';
import { getPathname } from 'common/selectors/location';
import { getIsPickupPoint } from 'features/store/ducks/get-store-by-id';
import { useEffectOnce } from '@navi-toolbox/hooks';
import { MainLayout } from '../main-layout';
import { GreyBlock } from './style';

export const Store: FC = () => {
  const regionId = useSelector(getRegionId);
  const isAuthorized = useSelector(getIsAuthorized);
  const url = useSelector(getPathname);
  const isPickupPoint = useSelector(getIsPickupPoint);

  useEffectOnce(() => {
    const onPageLoad = () => {
      analyticsUtils.sendEvent('GA:pageview', {
        pageType: 'ShopPage', // const тип страницы
        pagePath: url, // путь к странице
        userAuth: isAuthorized ? '1' : '0', // показатель авторизации
        platform: 'react', // const
        cityId: regionId, // id города
        businessModel: 'LM', // const
      });
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
    }
    return () => window.removeEventListener('load', onPageLoad);
  });

  return (
    <MainLayout>
      <StoreCommonInfo />
      {!isPickupPoint && (
        <GreyBlock>
          <ServiceCarousel />
          <StoreProjects />
        </GreyBlock>
      )}
      <StoreReviews />
    </MainLayout>
  );
};
